import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import Description from "../../components/admin-component/survey/Description";
import { addSurvey } from "../../redux/surveySlice";
import { api } from "../../services/api-service";

const SurveyDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      getSurvey();
    }
  }, []);

  const getSurvey = async () => {
    const response = await api.get(`get-survey/${id}`);
    if (response && response.ok) {
      dispatch(addSurvey(response.data.data));
    }
  };

  return (
    <div className="main-dashboard">
      <div className="mainWrapper">
        <Description />
      </div>
    </div>
  );
};

export default SurveyDetail;
